let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dMYd8")).then(() => parcelRequire('jAJJU'));